import { render } from "./ImageSelectModal.vue?vue&type=template&id=fcf6b844&scoped=true"
import script from "./ImageSelectModal.vue?vue&type=script&lang=ts"
export * from "./ImageSelectModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-fcf6b844"

export default script